<script>
import CandelaComponent from '@/components/CandelaComponent'
import {points} from '@/components/plots/atoms'

export default {
  computed: {
    colors() {
      return this.y.data.map((x, i) => {
        return this.settings.plot_colors.value(i)
      })
    },
    points() { return points(this.x, this.y, this.axis_x, this.axis_y) }
  },
  extends: CandelaComponent,
  name: 'candela-scatter-plot',
  data() {
    return {
      axis_x: null,
      axis_y: null,
      hover_label: ''
    }
  },
  methods: {
    update(axes) {
      this.axis_x = axes.x
      this.axis_y = axes.y
    }
  },
  props: {
    x: {type: Object, default: () => ({})},
    y: {type: Object, default: () => ({})},
    z: {type: Object, default: () => ({})}
  }
}
</script>

<template>
<div class='candela-component'>
  <candela-plot ref='plot' :id='id' :frame='frame' @update='update'>
    <candela-axis v-if='y' slot='axis_y' v-bind='y'/>
    <candela-axis v-if='x' slot='axis_x' v-bind='x'/>
    <g slot='content'>
      <g slot='background'>
        <candela-grid-lines v-if='settings.show_grid.value'
          :axis_x='axis_x' :axis_y='axis_y'/>
      </g>
      <g v-for='(point_list, i) in points' :key='i'>
        <g v-if='settings.point_style.value == "Circles"
          || settings.point_style.value == "Solid Circles"'>
          <circle v-for='(p, j) in point_list' :key='`point-${j}`' class='point'
            @mouseover='hover_label = `label-${j}`' @mouseout='hover_label = null'
            :transform='`translate(${p[0]} ${p[1]})`'
            :r='settings.point_radius.value'
            :stroke='settings.point_style.value == "Circles" ? colors[i] : "none"'
            :fill='settings.point_style.value == "Solid Circles" ? colors[i] : "none"'/>
        </g>
        <!--
        <text v-for='(p, j) in point_list[0]' :ref='`label-${j}`'
          :key='`label-${j}`' class='point-label'
          :transform='`translate(${p[0]} ${p[1]-8})`'
          :opacity='hover_label ? hover_label == `label-${j}` ? 1.0 : 0.0 : 1.0'>{{p[3] ? p[3] : ''}}
        </text>
        -->
      </g>
    </g>
    <div v-if='settings.show_legend.value' slot='bottom-content'>
      <candela-legend :index='y.index' :type='"circle"' :colors='colors'/>
    </div>
  </candela-plot>
</div>
</template>
<style lang='sass' scoped>
.point
  cursor: pointer

.point-label
  font-size: 10px
  pointer-events: none
  text-anchor: middle
  text-transform: uppercase
</style>
